import {
  NumberedHTMLWrapper,
  NumberedSectionContainer,
} from '../../workflows/sectionStyledComponents';
import type { SurveyProps } from './types';

const SurveyInfo = ({ question }: SurveyProps) => {
  return (
    <NumberedSectionContainer>
      <NumberedHTMLWrapper innerHtml={question.text} />
    </NumberedSectionContainer>
  );
};

export default SurveyInfo;
